import { FirmwareType } from '../support/pages/firmware-page'

const canActivateFirmware = (firmwareType: FirmwareType): boolean => {
    return firmwareType === FirmwareType.Master
}

export default canActivateFirmware
